<template>
  <generic-list
          :apiUrls="apiUrls"
          :formCols="formCols"
          :updateCols="updateCols"
          :tableCols="tableCols" 
  ></generic-list>
</template>

<script>
  import genericList from '@/views/commonPage/genericList.vue'
  import URL from '@/views/business/util/url'
  let isDelete = {"1":"启用","2":"禁用"};
  export default {
    name: "sysParam",
    components: {
      genericList
    },
    data() {
      return {
        apiUrls: {
          query: URL.sysParam.query,
          addOrUpdate: URL.sysParam.addOrUpdate,
          deleteBatchIds: URL.sysParam.deleteBatchIds
        },
        formCols: [

                       { title: '参数名', field: 'paramName' },
                       { title: '参数KEY', field: 'paramKey' },
                       { title: '参数值', field: 'paramValue' },
                       { title: '数据状态', field: 'isDelete',type:2,optionList:isDelete},
                                    
          { click: window.$t('business.bt.search') },
          { click: window.$t('business.bt.add'), auth: 'business:sysParam:save' }
        ],
        updateCols: [
          { title: 'ID', field: 'id',hidden:true},
          { title: '参数名', field: 'paramName',required:true},
          { title: '参数KEY', field: 'paramKey',required:true},
          { title: '参数值', field: 'paramValue',required:true}
    
        ],
        tableCols: [
                      { title: '参数名', field: 'paramName' },
                      { title: '参数KEY', field: 'paramKey' },
                      { title: '参数值', field: 'paramValue' },
                      { title: '创建时间', field: 'createDate' },
                      { title: '创建人', field: 'createUser' },
                      { title: '修改人', field: 'updateUser' },
                      { title: '修改时间', field: 'updateDate' },
                      
        {
          title: '数据状态', field: 'isDelete', render: (data, full) => {
            return isDelete[data];
          }
        },
        {title:window.$t("business.bt.operation"),minWidth:"180",btnClick:[
                 {name:window.$t("business.bt.edit"),click:"update",type:"primary",size:"mini",icon: "el-icon-edit",auth:'business:sysParam:edit'}
                
                 ]},
        ]
      };
    }
  }
</script>